var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"LeftTop"}},[_c('dv-border-box-13',[_c('HeaderTitle',{attrs:{"title":"车辆总览"}}),_c('LeftTopEchart')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }